import { PageScroll } from '@/layouts/page-layout';
import BuilderSettingsWidget from './builder-settings-widget';

export default function AdminSettingsPage() {
	return (
		<PageScroll contentClassName='p-2 flex flex-col gap-4'>
			<p className='text-sm text-muted-foreground -mt-1 mb-1'>Управление модулями и параметрами системы</p>
			<div className='flex flex-col gap-4'>
				<BuilderSettingsWidget />
			</div>
		</PageScroll>
	);
}
